import React from 'react';
import { Col, Form, Radio, Row, Slider } from 'antd';
import { SketchPicker } from 'react-color';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { ButtonActionPage } from '../../atoms';
import { COMMON_TRANSLATION } from '../../../constants/define/translation';
import { Align } from '../../../types/common';

interface WrapperDesignProps {
  textColor: string;
  isShowColorPicker: boolean;
  onChangeInput: (value: any) => void;
  onShowColorPicker: () => void;
  onCloseColorPicker: () => void;
  handleChangeColor: (value: any) => void;
}

export const WrapperDesign = (props: WrapperDesignProps) => {
  const { t } = useTranslation(COMMON_TRANSLATION);

  const { textColor, isShowColorPicker, onChangeInput, onShowColorPicker, onCloseColorPicker, handleChangeColor } =
    props;

  return (
    <StyledWrapper>
      <Row gutter={[16, 16]}>
        <Col span={11}>
          <Form.Item label={t('textColor')}>
            <ButtonActionPage text="Pick" id="1" className="btn-pick-color" onClick={onShowColorPicker} />
            {isShowColorPicker && (
              <div className="popover">
                <div
                  className="cover"
                  onClick={onCloseColorPicker}
                  onKeyDown={onCloseColorPicker}
                  role="button"
                  tabIndex={0}
                >
                  {' '}
                </div>
                <SketchPicker color={textColor} onChange={handleChangeColor} />
              </div>
            )}
          </Form.Item>
        </Col>
        <Col span={11} offset={2} style={{ paddingRight: 0, paddingLeft: 0 }}>
          <Form.Item name="colorOpacity" label={t('colorOpacity')}>
            <Slider min={0} max={1} step={0.01} onChange={onChangeInput} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={11}>
          <Form.Item name="textAlign" label={t('textAlign')}>
            <Radio.Group onChange={onChangeInput}>
              <Radio value={Align.LEFT}>Left</Radio>
              <Radio value={Align.CENTER}>Center</Radio>
              <Radio value={Align.RIGHT}>Right</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col span={11} offset={2}>
          <Form.Item name="buttonAlign" label={t('buttonAlign')}>
            <Radio.Group onChange={onChangeInput}>
              <Radio value={Align.LEFT}>Left</Radio>
              <Radio value={Align.CENTER}>Center</Radio>
              <Radio value={Align.RIGHT}>Right</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .popover {
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 30%;
  }

  .cover {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .sketch-picker {
    cursor: pointer;
  }

  & .ant-slider:hover .ant-slider-rail,
  & .ant-slider-rail {
    background-color: #6e6e6e;
  }
`;
